import { DialogContentText } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import { FC, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, FormButton } from 'thermia-react-container';
import { RegistrationsContext } from '../../../context/contextProvider';
import {useRefreshData} from "../../registration/hooks/useRefreshData";

interface Props {
  selectedRegistrationId?: string;
  handleClose: () => void;
}

type PageStatus = 'init' | 'success' | 'error';

const DeleteRegistrationForm: FC<Props> = ({ handleClose, selectedRegistrationId }) => {
  const [pageStatus, setPageStatus] = useState<PageStatus>('init');
  const [loading, setLoading] = useState<boolean>(false);
  const { registrations } = useContext(RegistrationsContext);
  const { deleteRegistrationAction } = registrations;
  const refreshData = useRefreshData();
  const { t } = useTranslation('registrations');

  const handleDeleteRegistration = async () => {
    if (!selectedRegistrationId) {
      return;
    }
    setLoading(true);
    try {
      await deleteRegistrationAction(selectedRegistrationId);
      refreshData();
      setPageStatus('success');
    } catch (e) {
      setPageStatus('error');
    }
    setLoading(false);
  };

  return (
    <Grid container direction="column" justifyContent="center" alignItems="center">
      {pageStatus === 'init' && (
        <>
          <DialogTitle>{t('registrations.general.deleteRegistration')}</DialogTitle>
          <DialogContent>
            <DialogContentText>{t('registrations.general.deleteRegistrationQuestion')}?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} title={t('registrations.general.no')} />
            <FormButton
              variant={'contained'}
              onClick={handleDeleteRegistration}
              title={t('registrations.general.yes')}
              loading={loading}
              style={{ marginLeft: '0px' }}
            />
          </DialogActions>
        </>
      )}

      {pageStatus === 'success' && (
        <>
          <DialogTitle>{t('registrations.general.success')}</DialogTitle>
          <DialogContent>
            <DialogContentText>{t('registrations.general.deleteRegistrationSuccessDescription')}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button title={t('registrations.general.ok')} onClick={handleClose} />
          </DialogActions>
        </>
      )}
      {pageStatus === 'error' && (
        <>
          <DialogTitle>{t('registrations.general.somethingWentWrong')}</DialogTitle>
          <DialogContent>
            <DialogContentText>{t('registrations.general.deleteRegistrationErrorDescription')}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button title={t('registrations.general.ok')} onClick={handleClose} />
          </DialogActions>
        </>
      )}
    </Grid>
  );
};

export default DeleteRegistrationForm;
